<template>
  <el-card class="file-card--com box-card" shadow="hover">
    <div slot="header" class="clearfix"  @click="openPDF(cardData.title, url, cardData.id, cardData)">
      <span class="title" @click.stop="" @mousedown.left.stop="copyClick(cardData.title, url, cardData.id, $event)">
        {{cardData.title || getUrlName(url)}}
      </span>
      <span style="flex: 1;"></span>
      <!-- <i class="el-icon-star-on" v-if="!hideFav && cardData.collectionType" @click.stop="doDeleteFavorite(cardData)">取消收藏</i>
      <i class="el-icon-star-off" v-else-if="!hideFav" @click.stop="doAddFavorite(cardData)">收藏</i>
      <i v-if="isFile" class="el-icon-s-comment" @click.stop="writeComment(cardData.id)">评论</i> -->
      <i class="el-icon-view" type="primary">查看文件</i>
    </div>
    <div class="text item"  @click="openPDF(cardData.title, url, cardData.id, cardData)">
      <docTip :message="cardData.message"></docTip>
      <div class="file-remark" v-if="/^remark:/.test(cardData.message)">
        {{cardData.message.replace(/^remark:/, '')}}
      </div>
      <div class="tip">
        <p class="item" v-if="cardData.uploadTime" @click.stop="" @mousedown.left.stop="copyClick(cardData.title, url, cardData.id, $event)">发布时间：{{cardData.releaseTime}}</p>
        <p class="item item-active" v-if="cardData.implementTime" @click.stop="" @mousedown.left.stop="copyClick(cardData.title, url, cardData.id, $event)">实施日期：{{cardData.implementDate}}</p>
        <p class="item" v-if="cardData.classa" @click.stop="" @mousedown.left.stop="copyClick(cardData.title, url, cardData.id, $event)">分类：{{cardData.classa}}</p>
      </div>
    </div>
    <span class="copy-box" ref="copyRef" @click="handleCopy()">复制(ctrl + c)</span>
    <nut-dialog
      :visible="showGetInfo"
      title="查看详情"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <span v-for="(item, index) in readMessage.split('+/b+')" :key="index">
        {{item.split('+b+')[0]}}<b>{{item.split('+b+')[1]}}</b>
      </span>
      <div align="center">
        <el-button type="primary" @click="cancel" style="width:100px;height:36px;">取消</el-button>
        <el-button type="primary" @click="sure" style="width:100px;height:36px;">确定</el-button>
      </div>
    </nut-dialog>
  </el-card>
</template>

<script>
import api from '../../../api/index'
import docTip from '../search/docTip.vue'
export default {
  props: ['cardData', 'hideFav'],
  data () {
    return {
      showAddressList: false,
      goodsDetail: {},
      showGetInfo: false,
      readMessage: '',
      itemElse: {}
    }
  },
  methods: {
    getUrlName (url) {
      var tmpArr = url.split('/')
      var name = tmpArr[tmpArr.length - 1]
      return name
    },
    doDeleteFavorite (item) {
      this.$emit('delete', item)
    },
    doAddFavorite (item) {
      this.$emit('add', item)
    },
    // handleAddressClose (item) {
    //   this.loading = this.$loading()
    //   api.addOrder({
    //     convertNumbers: 1,
    //     consigneeId: item.id,
    //     waresId: this.goodsId,
    //     isPrize: 1
    //   }).then(res => {
    //     this.loading && this.loading.close()
    //     this.showAddressList = false
    //     if (res.code === 200) {
    //       this.$confirm('我们会尽快安排发货，可以在个人中心，查看已兑换奖品列表哦~', '领取成功', {
    //         type: 'success',
    //         confirmButtonText: '前往查看',
    //         cancelButtonText: '稍后查看'
    //       }).then(() => {
    //         this.$router.push('/personal-center?hash=gift')
    //       }).catch(() => {
    //       })
    //     } else {
    //       this.$message({
    //         type: 'warning',
    //         message: res.message || '兑换失败，请稍后再试'
    //       })
    //     }
    //   })
    // },
    openPDF (name, link, id, detailData) {
      var tmpType = 0
      if (this.isFile) {
        tmpType = 0
      } else if (this.isReport) {
        tmpType = 1
      } else if (this.isAsk) {
        tmpType = detailData.termId ? 3 : 4
      } else if (this.isOther) {
        tmpType = 2
      }
      var sub = detailData.sub ? Number(detailData.sub) : 0
      if (sub) {
        api.subscription({
          phone: sessionStorage.getItem('qs_phone') || '',
          fileId: id,
          type: tmpType
        }).then(resA => {
          // this.readable = resA.data.readable
          this.readMessage = resA.data.readMessage
          // this.type5 = resA.data.type
          if (resA.data.readable === 0) {
            this.itemElse = detailData
            this.showGetInfo = true
          } else if (resA.data.readable === 1) {
            api.countDownload({
              fileId: id,
              type: this.isFile ? 0 : (this.isReport ? 1 : 2)
            }).then(res => {
              if (res.code === 500) {
                this.loading && this.loading.close()
                // this.$message({
                //   message: res.message,
                //   type: 'warning'
                // })
              } else if (res.code === 200) {
                this.$emit('openPDF', name, link, id, this.cardData)
              }
            })
          }
        })
      } else {
        api.countDownload({
          fileId: id,
          type: this.isFile ? 0 : (this.isReport ? 1 : 2)
        }).then(res => {
          if (res.code === 500) {
            this.loading && this.loading.close()
            // this.$message({
            //   message: res.message,
            //   type: 'warning'
            // })
          } else if (res.code === 200) {
            this.$emit('openPDF', name, link, id, this.cardData)
          }
        })
      }
    },
    cancel () {
      this.showGetInfo = false
    },
    sure () {
      this.showGetInfo = false
      api.countDownload({
        fileId: this.itemElse.id,
        type: 2
      }).then(res => {
        if (res.code === 200) {
          // this.$message({
          //   message: res.message,
          //   type: 'success'
          // })
          window.open(res.data.url)
          // ipcRenderer.send('ipcDownloadBegin', res.data.url)
        }
      })
    },
    copyClick (name, link, id, e) {
      var downPageX = e.pageX
      e.target.onmouseup = (event) => {
        if (Math.abs(downPageX - event.pageX) < 5) {
          this.openPDF(name, link, id, this.cardData)
        } else {
          this.showCopy(e)
        }
      }
    },
    showCopy (e) {
      this.$refs.copyRef.style.display = 'block'
      this.$refs.copyRef.style.top = e.target.offsetTop + e.target.clientHeight + 'px'
      this.$refs.copyRef.style.left = e.target.offsetLeft + e.target.clientWidth / 3 + 'px'
      this.selStr = window.getSelection().toString()
    },
    handleCopy (str) {
      var aux = document.createElement('input')
      aux.setAttribute('value', str || this.selStr)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$refs.copyRef.style.display = 'none'
    }
  },
  computed: {
    url () {
      return this.cardData.url || this.cardData.presentationUpload
    },
    isFile () {
      return Boolean(this.cardData.url && this.cardData.isQuestion === 1)
    },
    isReport () {
      return Boolean(this.cardData.presentationUpload)
    },
    isOther () {
      return Boolean(this.cardData.url && this.cardData.isQuestion === undefined)
    }
  },
  directives: {
    showMore: function (el) {
      setTimeout(() => {
        if (el.querySelector('.text-wrap').clientHeight > 30) {
          el.querySelector('.more-btn').style.display = 'block'
          el.querySelector('.more-btn').onclick = function () {
            el.style.height = 'auto'
            el.querySelector('.more-btn').style.display = 'none'
            el.querySelector('.less-btn').style.display = 'inline-block'
          }
          el.querySelector('.less-btn').onclick = function () {
            el.style.height = '20px'
            el.querySelector('.more-btn').style.display = 'block'
          }
        }
      })
    }
  },
  components: {
    docTip
  }
}
</script>

<style lang="scss">
.file-card--com.box-card {
  margin: 8px;
  position: relative;
  overflow: visible;
  cursor: pointer;
  .el-card__header {
    padding: 8px 12px;
  }
  .el-card__body {
    padding: 8px 12px;
    overflow: hidden;
  }
  .clearfix {
    display: flex;
    align-items: center;
    .title {
      flex: 1 1 auto;
      -webkit-user-select: text;
      font-size: 16px;
      font-weight: 600;
    }
    i {
      flex: 0 0 auto;
      margin-left: 12px;
      font-size: 12px;
      color: #83889a;
      &:hover {
        cursor: pointer;
        color: #409EFF;
      }
    }
    .share-icon {
      flex: 0 0 auto;
    }
  }
  .preface {
    .preface-des {
      text-indent: 2em;
    }
  }
  .tip {
    color: #83889a;
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    p {
      flex: 0 0 46%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-user-select: text;
      &.item-active {
        color: #409eff;
      }
    }
  }
  .file-remark {
    color: #606266;
    margin-bottom: 4px;
    border-left: 4px solid #ccc;
    padding: 0 4px;
    line-height: 1.3;
  }
  .answer-line {
    height: 20px;
    overflow: hidden;
    position: relative;
    .more-btn {
      position: absolute;
      right: 0;
      bottom: 0;
      background: linear-gradient(to right, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 1));
      display: none;
      padding-left: 80px;
      cursor: pointer;
      color: #409EFF;
      line-height: 1.3;
    }
    .less-btn {
      display: none;
      cursor: pointer;
      color: #409EFF;
    }
  }
  .ask-icon {
    border-radius: 4px;
    height: 20px;
    width: 20px;
    text-align: center;
    line-height: 20px;
    background: #E6A23C;
    margin: 0!important;
    font-style: normal;
    display: inline-block;
    vertical-align: text-bottom;
    color: #fff!important;
    &.answer {
      background: #67C23A;
      color: #fff!important;
    }
  }
  .copy-box {
    position: absolute;
    z-index: 10;
    font-weight: normal;
    font-size: 12px;
    border: 1px solid #ebecf1;
    padding: 2px 4px;
    background: #F2F6FC;
    display: none;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    &:hover {
      background: #409EFF;
      color: #fff;
    }
  }
  .gift-address {
    position: relative;
    .des {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 8px 0;
      .title {
        flex: 1;
        font-size: 22px;
      }
      img {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 4px;
        object-fit: cover;
        margin-right: 8px
      }
    }
    .icon {
      position: absolute;
      width: 60px;
      left: 120px;
      top: 40px;
      opacity: 0.7;
      z-index: 0;
      transform: rotate(-15deg);
    }
  }
}
</style>
